import { render, staticRenderFns } from "./CriarFaq.vue?vue&type=template&id=15577d56&"
import script from "./CriarFaq.vue?vue&type=script&lang=js&"
export * from "./CriarFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports